interface GameLoadingSpinnerProps {
  message?: string;
}

export default function GameLoadingSpinner({ message = 'Loading game…' }: GameLoadingSpinnerProps) {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: 'var(--bg)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2,
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          border: '2px solid var(--line-2)',
          borderTopColor: 'var(--accent)',
          animation: 'spin 0.9s linear infinite',
          marginBottom: 18,
        }}
      />
      <div className="display" style={{ fontSize: 16, marginBottom: 6 }}>{message}</div>
      <div className="muted" style={{ fontSize: 12 }}>Initializing WebGL runtime…</div>

      <style>{`@keyframes spin { from { transform: rotate(0); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
